import { observer, useLocalObservable } from "mobx-react";
import TopTabs from "../HomePage/component/TopTabs";
import React, { useEffect } from "react";
import MyPageStore from "./store/MyPageStore";
import LogoutIcon from "@mui/icons-material/Logout";
import { useRootStore } from "store/StoreContextProvider";
import { Button, Divider, Grid } from "@mui/material";
import MyPageTopArea from "./component/MyPageTopArea";
import MyPageMiddleArea from "./component/MyPageMiddleArea";
import MyPageBottomArea from "./component/MyPageBottomArea";
import MyPageGoalModal from "./component/MyPageGoalModal";
import TopHeader from "pages/HomePage/component/TopHeader";
import HeaderContent from "component/layout/HeaderContent";
import { UserModel } from "domains/models/UserModel";
import useSnackbarMessage from "shared/snackbar";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

function MyPage() {
  const { headerStore, loginStore } = useRootStore();
  const snackbar = useSnackbarMessage();
  const pageStore = useLocalObservable(() => new MyPageStore());
  const navigate = useNavigate();
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    headerStore.setPageTitle("MyPage");
    fetchMyInfo();
  }, []);

  const fetchMyInfo = async () => {
    try {
      const myinfo: UserModel = await pageStore.fetchMyInfo();

      const res = await pageStore.fetchMyAssess(myinfo);
      if (res?.expired) {
        instance.logout();
        loginStore.onLogout();
        navigate("/login");
        return;
      }
    } catch (err: any) {
      console.log(err);
      snackbar.error(err.message);
    }
  };

  const handleLogoutButton = () => {
    instance.logout();
    loginStore.onLogout();
    navigate("/login");
  };

  return (
    <HeaderContent>
      <TopHeader />
      <Button
        style={{ position: "absolute", top: "35px", right: "15px" }}
        onClick={handleLogoutButton}
      >
        <LogoutIcon style={{ fill: "#2281D0" }} />
      </Button>
      <Divider
        style={{
          border: "0.5px solid #eeeeee",
          marginTop: "13px",
          width: "100%",
        }}
      />
      <Grid container spacing={2} style={{ padding: "20px 20px 80px 20px" }}>
        <Grid item xs={12} sm={12} md={6}>
          <MyPageTopArea pageStore={pageStore} />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <MyPageMiddleArea pageStore={pageStore} />
          {/* <MyPageBottomArea /> */}
        </Grid>
      </Grid>
      <MyPageGoalModal pageStore={pageStore} />
    </HeaderContent>
  );
}

export default observer(MyPage);
